(() => {
  'use strict';

  if (window.__fpPalastFavoritenNavigationV1) return;
  window.__fpPalastFavoritenNavigationV1 = true;

  const selector = '[data-fp-palast-favoriten]';

  const initializeSection = (root) => {
    if (root.dataset.fpNavigationReady === 'true') return;

    const viewport = root.querySelector('[data-fp-groups]');
    const groups = Array.from(root.querySelectorAll('[data-fp-group]'));
    const navigation = root.querySelector('[data-fp-navigation]');
    const previous = navigation?.querySelector('[data-fp-prev]');
    const next = navigation?.querySelector('[data-fp-next]');
    const counter = navigation?.querySelector('[data-fp-counter]');

    if (!viewport || groups.length === 0) return;
    if (groups.length === 1) {
      groups[0].hidden = false;
      return;
    }
    if (!navigation || !previous || !next || !counter) return;

    root.dataset.fpNavigationReady = 'true';
    let activeIndex = 0;

    const showGroup = (index) => {
      activeIndex = ((index % groups.length) + groups.length) % groups.length;
      groups.forEach((group, groupIndex) => {
        group.hidden = groupIndex !== activeIndex;
      });
      counter.textContent = `${activeIndex + 1} / ${groups.length}`;
    };

    showGroup(0);
    navigation.hidden = false;

    previous.addEventListener('click', () => showGroup(activeIndex - 1));
    next.addEventListener('click', () => showGroup(activeIndex + 1));

    navigation.addEventListener('keydown', (event) => {
      if (event.target !== previous && event.target !== next) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showGroup(activeIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        showGroup(activeIndex + 1);
      }
    });

    let startX = 0;
    let startY = 0;
    let trackingTouch = false;
    let suppressClickUntil = 0;

    viewport.addEventListener('touchstart', (event) => {
      trackingTouch = event.touches.length === 1;
      if (!trackingTouch) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });

    viewport.addEventListener('touchend', (event) => {
      if (!trackingTouch || event.changedTouches.length === 0) return;
      trackingTouch = false;

      const deltaX = event.changedTouches[0].clientX - startX;
      const deltaY = event.changedTouches[0].clientY - startY;
      if (Math.abs(deltaX) < 55 || Math.abs(deltaX) < Math.abs(deltaY) * 1.3) return;

      suppressClickUntil = Date.now() + 450;
      showGroup(activeIndex + (deltaX < 0 ? 1 : -1));
    }, { passive: true });

    viewport.addEventListener('touchcancel', () => {
      trackingTouch = false;
    }, { passive: true });

    viewport.addEventListener('click', (event) => {
      if (Date.now() > suppressClickUntil) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  };

  const initializeWithin = (scope) => {
    if (!scope || typeof scope.querySelectorAll !== 'function') return;
    if (typeof scope.matches === 'function' && scope.matches(selector)) {
      initializeSection(scope);
    }
    scope.querySelectorAll(selector).forEach(initializeSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
  } else {
    initializeWithin(document);
  }

  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
